import { startCase } from 'lodash';
import { useIsManufacturer } from '../../hooks';

import Money from '../../Parts/Money';

export default function ShadeContainer(props) {
	const { shade } = props;
	const isManufacturer = useIsManufacturer();

	const EXCLUDE_FIELDS = ['shade_name', 'tube', 'id', 'shade_id', 'motor_type'];

	const obj = shade.savableObject();
	
	const fields = Object.keys(obj)
		.filter((key) => !EXCLUDE_FIELDS.includes(key))
		.map((key) => (

			<div key={key} style={{ maxWidth: '300px', whiteSpace: 'no-wrap' }}>
				{ startCase((`${key}`).replace(/\_/g, ' ')) }
:
				<b>{ obj[key] ? startCase((`${obj[key]}`).replace(/\_/g, ' ')) : 'N/A' }</b>
			</div>
		));

	return (

		<div className={`shade-container`}>

			<h2>
Room:
				<span>{ shade.val('room_name') }</span>
			</h2>
			<h3>
Shade:
				<span>{ shade.val('shade_name') }</span>
			</h3>
			{
				isManufacturer
					? null
					:					(
						<h3 className="shade-container-msrp">
MSRP:
							<span><Money symbol={props.currencyData.symbol}>{ parseFloat(shade.val('msrp')) * props.currencyData.multiplier }</Money></span>
						</h3>
					)
			}
			<div className="shade-fields">
				{ fields }
			</div>

		</div>
	);
}
